module.exports = __webpack_public_path__ + "img/desktop-login-vector.c9aa7014fc15cfbf07a5.66600a33.png";